import React, { useEffect, useMemo, useState } from "react"
import { Route, withRouter } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { map, includes, isEmpty } from "lodash"
import ReactResizeDetector from "react-resize-detector"
import { SymbolDetail } from "components/pages/others/symbolDetail"
import { SubNav } from "components/molecules/nav"
import useNodeDistManager from "node-dist/useNodeDistManager"
import {
  MainContentsType,
  ParentRouteProps,
  ChildrenRouteProps,
  useMainContents,
} from "./mainContents"
import { Ticker } from "components/molecules/ticker"
import { checkIsSp, checkParentWindow } from "utils/util"
import { UserStorage } from "utils/userStorage"
import { chartColorSetting } from "redux/ducks/Chart"
import chartColors from "components/atoms/chart/logic/chartColor"
import { SwitchBtn } from "components/atoms/btn"
import ClassNames from "classnames"
import store from "redux/store"
import {
  setAutoLoading,
  setManualLoading,
  LoadingType,
} from "redux/ducks/AutoLoadingFlag"
import { pageLoad } from "redux/ducks/PageLoad"
import { CoverLoading } from "components/atoms/utils"
import SessionTimeOut from "./sessionTimeOut"
import { pushSymbolList, unregisterAll } from "node-dist/nodeDistManager"

const SymbolRegisterMainContents: React.FC<MainContentsType> = props => {
  //DEMO版なのでNodeDistに接続しない
  // useNodeDistManager()
  const { route, childrenRoute } = useMainContents(props)
  const dispatch = useDispatch()
  const autoLoadingFlag = useSelector(
    (state: { AutoLoadingFlag: LoadingType }) =>
      state.AutoLoadingFlag.autoLoading
  )

  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])

  useEffect(() => {
    checkParentWindow()
  }, [])

  return (
    <>
      <main className="main-content">
        <ReactResizeDetector
          handleWidth={true}
          render={({ width }) => (
            <div className="register-header">
              <SubNav
                route={childrenRoute}
                pathname={props.location.pathname}
                windowWidth={width}
              />
              <div className="header-content">
                <Ticker history={props.history} isPush={autoLoadingFlag} />
                <div className="register-header-buttons">
                  <label className="btn shaped theme-color-btn">
                    <input
                      type="checkbox"
                      className="input-multi-control"
                      onChange={() => {
                        const elements = document.querySelector("html")
                          .classList
                        if (includes(elements, "dark")) {
                          elements.add("bright")
                          elements.remove("dark")
                        } else {
                          elements.add("dark")
                          elements.remove("bright")
                        }
                        const ChartColors = includes(elements, "dark")
                          ? UserStorage.TechChartColor.getDark()
                          : UserStorage.TechChartColor.getWhite()
                        dispatch(
                          !isEmpty(ChartColors)
                            ? chartColorSetting(ChartColors)
                            : chartColorSetting(chartColors.initialize())
                        )
                      }}
                      checked={false}
                    />
                    <i className="material-icons">color_lens</i>
                    <div className="title-text">テーマ切替</div>
                  </label>
                  <div className="register-header-button auto-update-btn">
                    <SwitchBtn
                      names={["自動更新", "手動更新"]}
                      onClick={() => {
                        if (autoLoadingFlag) {
                          store.dispatch(setManualLoading())
                          unregisterAll()
                        } else {
                          store.dispatch(setAutoLoading())
                          pushSymbolList()
                        }
                      }}
                    />
                  </div>
                  <div
                    className="register-header-button "
                    onClick={() => store.dispatch(pageLoad())}
                  >
                    <i
                      className={ClassNames("material-icons", {
                        "auto-loading": autoLoadingFlag,
                      })}
                      title={!autoLoadingFlag && "手動更新"}
                    >
                      autorenew
                    </i>
                  </div>
                </div>
              </div>
            </div>
          )}
        />
        <div className="symbol-list-page">
          {props.route.map((row: ParentRouteProps, i: number) => (
            <Route
              exact={row.renderingInMain}
              key={i}
              path={row.path}
              component={row.component}
            />
          ))}
          {route !== undefined && route.renderingInMain
            ? map(childrenRoute, (row: ChildrenRouteProps, key: number) => (
                <Route
                  key={key}
                  path={row.path}
                  //props追加などで汎用的にするために、このように指定
                  component={() => React.createElement(row.component)}
                />
              ))
            : null}
          {isSp && <SymbolDetail />}
        </div>
        <CoverLoading targetCls="main-content" />
      </main>
      <SessionTimeOut />
    </>
  )
}

export default withRouter(SymbolRegisterMainContents)
